import React from 'react';
import { Box, IconButton, Typography } from '@material-ui/core';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import ReactJson from 'react-json-view';

interface JsonViewerProps {
    header?: string;
    content: string | object;
    onCopy?: (value: string) => void;
    style?: React.CSSProperties;
    maxHeight?: number;
}

const safeParse = (value: string | object) => {
    if (!value) return null;

    if (typeof value === 'object') return value;

    try {
        return JSON.parse(value);
    } catch {
        return { error: 'Invalid DID Document JSON' };
    }
};

const JsonViewer: React.FC<JsonViewerProps> = ({
    header,
    content,
    onCopy,
    style,
    maxHeight = 360
}) => {
    const parsed = safeParse(content);

    const handleCopy = () => {
        if (!content) return;
        onCopy?.(typeof content === 'string' ? content : JSON.stringify(content, null, 2));
    };

    return (
        <Box>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: (header || onCopy) && 10
                }}>
                <Typography>{header}</Typography>

                {onCopy && (
                    <IconButton
                        size="small"
                        onClick={handleCopy}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            border: '1px solid #e0e0e0',
                            borderRadius: 6,
                            padding: 6,
                            backgroundColor: '#fff'
                        }}>
                        <FileCopyOutlinedIcon style={{ fontSize: 16, color: '#555' }} />
                    </IconButton>
                )}
            </Box>

            {/* Body */}
            <Box
                style={{
                    ...style,
                    borderRadius: 8,
                    border: '1px solid #1eb89a',
                    overflow: 'hidden'
                }}>
                <Box
                    style={{
                        backgroundColor: '#f6f8fa',
                        padding: '12px 0 12px 12px',
                        maxHeight: maxHeight,
                        overflowY: 'auto'
                    }}>
                    <div
                        style={{
                            paddingRight: 12,
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere',
                            whiteSpace: 'pre-wrap'
                        }}>
                        {parsed && (
                            <ReactJson
                                src={parsed}
                                name={false}
                                theme="rjv-default"
                                displayDataTypes={false}
                                displayObjectSize={false}
                            />
                        )}
                    </div>
                </Box>
            </Box>
        </Box>
    );
};

export default JsonViewer;
